import {
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Fragment } from "react";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  customTopheader: { title: string; size: number }[];
  header: string[];
  data: any;
  fundApplicationYears?: number[];
  onStateClick?: (stateName: string) => void;
};

export function FundApplicationDashBoardTable({
  data,
  header,
  customTopheader,
  fundApplicationYears = [],
  onStateClick,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {customTopheader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell", { minWidth: "150px" })}
                key={index}
                colSpan={item.size}
              >
                {item.title}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow key={row.id ?? index}>
                <TableCell align="center" {...styles("cell")}>
                  {row.sno}
                </TableCell>
                <TableCell
                  align="center"
                  {...styles("cell", { width: "180px" })}
                >
                  {onStateClick && row.state !== "Total" ? (
                    <Link
                      component="button"
                      type="button"
                      underline="always"
                      onClick={() => onStateClick(row.state)}
                      title="Filter by this state; click again to remove the filter"
                      sx={{
                        color: "primary.main",
                        cursor: "pointer",
                        font: "inherit",
                        fontWeight: 500,
                      }}
                    >
                      {row.state}
                    </Link>
                  ) : (
                    row.state
                  )}
                </TableCell>
                {header.includes("Division") && (
                  <TableCell align="center" {...styles("cell")}>
                    {row.division}
                  </TableCell>
                )}
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberSelected}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaSelected}
                </TableCell> */}
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberDemandNoteRaised}
                </TableCell>
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaDemandNoteRaised}
                </TableCell> */}
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAmountDemandNoteRaised}
                </TableCell>
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberPaymentReceived}
                </TableCell> */}
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaPaymentReceived}
                </TableCell> */}
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAmountPaymentReceived}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalEcoRestorationCost}
                </TableCell>
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberFundApplicationPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaFundApplicationPending}
                </TableCell> */}
                {/* <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberFundApplicationReceived}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaFundApplicationReceived}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAmountFundApplicationReceived}
                </TableCell> */}
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberPaymentReleased}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAmountPaymentReleased}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalFinancialProgress}
                </TableCell>
                {fundApplicationYears.map((year) => {
                  const release = row.faPaymentReleased?.[`FA${year}`];
                  return (
                    <Fragment key={year}>
                      <TableCell align="center" {...styles("cell")}>
                        {release?.totalNumber ?? 0}
                      </TableCell>
                      <TableCell align="center" {...styles("cell")}>
                        {release?.totalAmount ?? "0.00"}
                      </TableCell>
                      <TableCell align="center" {...styles("cell")}>
                        {release?.totalUcUploaded ?? 0}
                      </TableCell>
                      <TableCell align="center" {...styles("cell")}>
                        {release?.totalUcPending ?? 0}
                      </TableCell>
                    </Fragment>
                  );
                })}
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAmountFundApplicationPending}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
